// modalConfig.js
import ModalComponents from "../components/modal";
import AttRecordModal from "../components/modal/AttRecordModal";
import EarlyReportModal from "../components/modal/hourlyReportModal";
import LateAttModal from "../components/modal/LateAttModal";

export const modalByPageName = {
  "Attendance Sheet": ModalComponents,
  "Attendance Records": AttRecordModal,
  "Early Exit Report": EarlyReportModal,
  "Monthly Report": ModalComponents,
  "Late Attendance Report": LateAttModal,
};
